import Stack from '@mui/material/Stack'
import { ReactNode } from 'react'

type Props = {
  children: ReactNode
}
const SkeletonStack = (props: Props) => {
  const { children } = props

  return <Stack spacing={1}>{children}</Stack>
}

export default SkeletonStack
